import {
  getDynamicBooksStructuredMediaAsset,
  getDynamicBooksStructuredMediaFormat,
  type DynamicBooksStructuredMediaAssetId,
  type DynamicBooksStructuredMediaFormat
} from "../../server/structuredMediaRegistry.js";

export type StructuredMediaImage = {
  assetId: DynamicBooksStructuredMediaAssetId;
  src: `/assets/dynamicbooks-v4-structured-media/${string}.${DynamicBooksStructuredMediaFormat}`;
  alt: string;
  width: number;
  height: number;
};

export type StructuredSoftwareTierKey = "basic" | "business" | "premium";

export const softwareTierStructuredMediaAssetByKey = {
  basic: "tier-basic",
  business: "tier-business",
  premium: "tier-premium"
} as const satisfies Record<StructuredSoftwareTierKey, DynamicBooksStructuredMediaAssetId>;

export const articleStructuredMediaAssetIds = [
  "article-agentdriven-bokforing-16x9",
  "article-agentdriven-bokforing-4x3",
  "article-agentdriven-bokforing-1x1"
] as const satisfies readonly DynamicBooksStructuredMediaAssetId[];

export function getStructuredMediaImage(
  assetId: DynamicBooksStructuredMediaAssetId,
  format: DynamicBooksStructuredMediaFormat = "png"
): StructuredMediaImage {
  const asset = getDynamicBooksStructuredMediaAsset(assetId);
  const media = getDynamicBooksStructuredMediaFormat(assetId, format);

  return {
    assetId,
    src: media.publicPath,
    alt: asset.alt,
    width: media.width,
    height: media.height
  };
}

export function getSoftwareTierStructuredMediaImage(tierKey: StructuredSoftwareTierKey): StructuredMediaImage {
  return getStructuredMediaImage(softwareTierStructuredMediaAssetByKey[tierKey]);
}
